import { matchesAdvisorFilter } from 'src/clients/components/AdvisorFilterSelect';
import { NOTIFICATION_CARDS, notificationGroupLabel } from 'src/notifications/notificationCards';
import type { Notification } from 'src/notifications/types/Notification';

function isActivelySnoozed(notification: Notification): boolean {
  return notification.snoozedUntil != null && new Date(notification.snoozedUntil) > new Date();
}

export function activeNotifications(notifications: Notification[]): Notification[] {
  return notifications.filter(n => n.status !== 'dismissed' && !isActivelySnoozed(n));
}

export function unreadCount(notifications: Notification[]): number {
  return activeNotifications(notifications).filter(n => n.status === 'unread').length;
}

export type StatusFilter = 'all' | 'unread';

export const ALL_GROUPS = '';

export type NotificationFilter = {
  status: StatusFilter;
  group: string;
  advisor: string | null;
};

export const defaultNotificationFilter: NotificationFilter = {
  status: 'all',
  group: ALL_GROUPS,
  advisor: null,
};

export function filterNotifications(
  notifications: Notification[],
  filter: NotificationFilter,
  advisorOf: (notification: Notification) => string | null,
): Notification[] {
  return activeNotifications(notifications).filter(notification => {
    if (filter.status === 'unread' && notification.status !== 'unread') {
      return false;
    }
    if (
      filter.group !== ALL_GROUPS &&
      notificationGroupLabel(notification.payload.type) !== filter.group
    ) {
      return false;
    }
    if (!matchesAdvisorFilter(advisorOf(notification), filter.advisor)) {
      return false;
    }
    return true;
  });
}

export function availableGroupLabels(notifications: Notification[]): string[] {
  const present = new Set(
    activeNotifications(notifications).map(n => notificationGroupLabel(n.payload.type)),
  );
  const ordered: string[] = [];
  for (const { groupLabel } of Object.values(NOTIFICATION_CARDS)) {
    if (present.has(groupLabel) && !ordered.includes(groupLabel)) {
      ordered.push(groupLabel);
    }
  }
  return ordered;
}
